import './Banner.css'

export const Banner = () => {
    return (
        <header className='banner'>
            <img src="imgs/banner.png"></img>
        </header>

    )
}
